/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import SuggestionCard from './d5-mfrm-suggestion-cards-content';

import { ID5MfrmSuggestionCardsData } from './d5-mfrm-suggestion-cards.data';
import { ID5MfrmSuggestionCardsProps } from './d5-mfrm-suggestion-cards.props.autogenerated';

export interface ID5MfrmSuggestionCardsViewProps extends ID5MfrmSuggestionCardsProps<ID5MfrmSuggestionCardsData> {
    suggestionCards: React.ReactNode[];
}

/**
 *
 * D5MfrmSuggestionCards component
 * @extends {React.PureComponent<ID5MfrmSuggestionCardsProps<ID5MfrmSuggestionCardsData>>}
 */
class D5MfrmSuggestionCards extends React.PureComponent<ID5MfrmSuggestionCardsProps<ID5MfrmSuggestionCardsData>> {
    public render(): JSX.Element | null {
        if (!this.props.config.suggestionCardsList) {
            return null;
        }

        const viewProps: ID5MfrmSuggestionCardsViewProps = {
            ...(this.props as ID5MfrmSuggestionCardsProps<ID5MfrmSuggestionCardsData>),
            suggestionCards: this._getsuggestionCards()
        };

        return this.props.renderView(viewProps);
    }

    private _getsuggestionCards = (): React.ReactNode[] => {
        const {
            config: { suggestionCardsList, isHorizontalCards },
            context: {
                request: { gridSettings }
            }
        } = this.props;

        return suggestionCardsList.map((sc, index) => {
            const {suggestionCardContent, suggestionCardHeading, suggestionCardImage, suggestionCardLink, suggestionCardLocationText, useDynamicImages, dynamicImages } = sc;
            return (
                <SuggestionCard
                    key={index}
                    cardIndex={index}
                    gridSettings={gridSettings!}
                    heading={suggestionCardHeading}
                    image={suggestionCardImage}
                    content={suggestionCardContent}
                    location={suggestionCardLocationText}
                    cardLink={suggestionCardLink}
                    isHorizontalCards={isHorizontalCards}
                    useDynamicImages={useDynamicImages}
                    dynamicImages={dynamicImages}
                />
            );
        });
    };
}

export default D5MfrmSuggestionCards;
